import React, { useEffect, useRef, useState} from "react";
import { Helmet } from "react-helmet-async";
import '../styles/contato.min.css';
import { Loader } from "@googlemaps/js-api-loader";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";

export default function Home() {

    const mapRef = useRef(null);
    const formRef = useRef();
    const recaptchaRef = useRef(null);

    useEffect(() => {
        const loader = new Loader({
        apiKey: "AIzaSyCNPMxWfe-QyWIHivqJMEq5vN5Me8jNBOM",
        version: "weekly",
        libraries: ["marker"], // para AdvancedMarkerElement
        });

        loader.load().then(() => {
        const local = { lat: -28.6831779, lng: -49.3769547 };

        const map = new window.google.maps.Map(mapRef.current, {
            zoom: 15,
            center: local,
            mapId: "DEMO_MAP_ID",
        });

        // Marker avançado
        const marker = new window.google.maps.marker.AdvancedMarkerElement({
            position: local,
            map: map,
            title: "Localização aqui!",
        });

        // InfoWindow
        const infoWindow = new window.google.maps.InfoWindow({
            content: `
                    <div style="font-size:14px; line-height:1.4">
                        R. Pedro Beneton, 335 - Centro<br/>
                        Criciúma - SC<br/>
                        88802-070<br/>
                        <a href="https://maps.app.goo.gl/j4cabYTfpQim92bi7"
                        target="_blank"
                        rel="noopener noreferrer">
                        Visualize no Google Maps
                        </a>
                    </div>`,
        });

        // Abrir info window ao clicar no marker
        marker.addListener("click", () => {
            infoWindow.open({
            anchor: marker,
            map,
            });
        });

        // Se quiser já aberto automaticamente:
        infoWindow.open({
            anchor: marker,
            map,
        });
    });
    }, []);

    const sendEmail = (e) => {
        e.preventDefault();
        
        const token = recaptchaRef.current.getValue();
        if (!token) {
            alert("Confirme o captcha antes de enviar!");
            return;
        }

        emailjs.sendForm(
            "service_3yuzpqr",
            "template_1oyjrxa",
            formRef.current,
            "zYEBiMSa4brw-TSSQ"
        ).then(() => {
            alert("Mensagem enviada com sucesso!");
            formRef.current.reset();
            recaptchaRef.current.reset();
        }).catch((err) => {
            console.error(err);
            alert("Erro ao enviar mensagem.<br>"+err.text);
        });

    };

   return (
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/contato" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma" />
        </Helmet>

        <main>
            <section>
                <div className="contato">

                    <ul className="contato-items">
                        <li className="contato-items-item contato-items-item--right">

                            <div className="pilates-aberta-class-unidade-map">
                                <div ref={mapRef} id="map" className="contato-map-container"></div>
                            </div>

                            <div className="">
                                <h2 className="contato-items-item--title">
                                    Contato OsteoVitta Pilates
                                </h2>
                                <p className="contato-items-item--text">
                                    Preencha abaixo seus dados e o assunto que deseja falar e muito em breve receberá nosso retorno.
                                </p>
                            </div>
                            

                            <form ref={formRef} id="form" className="contato-items-item--form" onSubmit={sendEmail}>
                                <input className="contato-items-item--form-input contato-items-item--form-input-name" type="text" id="nome" name="nome" placeholder="Nome e Sobrenome *" required />

                                <input className="contato-items-item--form-input contato-items-item--form-input-email" type="email" id="email" name="email" placeholder="E-mail "  />

                                <input className="contato-items-item--form-input contato-items-item--form-input-email" type="tel" id="telefone" name="telefone" placeholder="Telefone *" required  />

                                <input className="contato-items-item--form-input contato-items-item--form-input-name" type="text" id="assunto" name="assunto" placeholder="Assunto *" required />

                                <textarea className="contato-items-item--form-textarea" id="mensagem" name="mensagem" rows="6" cols="100" placeholder="Mensagem *" required></textarea>

                                <div className="contato-items-item--form-recaptcha" style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                                    <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6Ld_UdwrAAAAACGy3B9DeSzDHk78UhnvgaG8D5tc"
                                    />
                                </div>

                                <div className="contato-items-item--form-recaptcha" style={{marginTop: '20px', display: 'flex', justifyContent: 'center', width: '100%'}}>
                                    <button className="contato-items-item--form-button">Enviar</button>    
                                </div>
                                    
                            </form>
                        </li>
                    </ul>

                </div>
            </section> 
        </main>
    </>
  );
}